import React, { useRef, useEffect } from 'react';

const WebcamPreview = ({ stream }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '80px',
        right: '16px',
        zIndex: 1050,
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
        border: '2px solid #dc3545',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '6px',
          left: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          zIndex: 1,
        }}
      >
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: '#dc3545',
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
        <span
          style={{
            fontSize: '10px',
            fontWeight: 700,
            color: '#dc3545',
            textShadow: '0 0 4px rgba(0,0,0,0.5)',
          }}
        >
          REC
        </span>
      </div>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        style={{
          width: '180px',
          height: '135px',
          objectFit: 'cover',
          display: 'block',
          backgroundColor: '#000',
        }}
      />
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
};

export default WebcamPreview;
